<template>
  <div class="container">
    <i @click="closeMsg()" class="fas fa-times"></i>
    <div
      v-if="message.referente == undefined"
      class="row flex-column justify-content-between contatti"
    >
      <div class="col-md-12 row justify-content-between">
        <div class="col-md-4 text-center">
          <span
            ><strong>{{ message.nome }}</strong></span
          >
        </div>
        <div class="col-md-4 text-center">
          <a :href="'mailto:' + message.email">{{ message.email }}</a>
        </div>
        <div class="col-md-4 text-center">
          <span>{{ message.telefono }}</span>
        </div>
      </div>

      <div class="col-md-10 offset-md-1 text-left mb-5 mt-5">
        <span
          ><strong>{{ message.object }} </strong>-
          {{ getFormat(message.created_at) }}</span
        >
      </div>

      <div class="col-md-10 offset-md-1 text-justify testo">
        <p class="">{{ message.messaggio }}</p>
      </div>
      <div class="col-md-4 offset-md-8 mt-5">
        <a :href="'mailto:' + message.email">rispondi a {{ message.nome }}</a>
      </div>
    </div>

    <div v-else class="row flex-column justify-content-between contatti">
      <div class="col-md-10 offset-md-1 text-left mb-5 mt-5">
        <span
          ><strong>{{ message.referente }} </strong>-
          {{ getFormat(message.created_at) }}</span
        >
      </div>

      <div class="col-md-10 offset-md-1 text-justify testo">
        <img
          v-if="message.immagine"
          class="d-inline float-left mr-2 pointer"
          :src="'../' + message.immagine"
          alt=""
          @click="openImg = true"
        />
        <p class="d-inline">{{ message.testo }}</p>
      </div>
      <img
        class="big-img pointer"
        v-if="openImg"
        :src="'../' + message.immagine"
        alt=""
        @click="openImg = false"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "message",
  props: ["message"],
  data() {
    return {
      openImg: false,
    };
  },
  mounted() {},
  methods: {
    closeMsg: function () {
      this.$emit("closeMsg");
    },
    getFormat: function (when) {
      return dayjs(when).format("DD/MM/YYYY");
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  .fa-times {
    position: absolute;
    top: 0;
    right: 0;
    padding: 1rem;
  }
  background-color: #fff;
  width: 100%;
  height: 100%;
  padding: 2rem 0;
  .testo {
    height: 60%;
    img {
      width: 25%;
    }
  }
  .big-img {
    max-width: 80vw;
    max-height: 80vh;
    position: fixed;
    box-shadow: 0px 2px 8px #c4c4c6;
    border: 5px solid var(--green);
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
